import React from 'react';
import SPSelectWithEnum from 'components/product-price/base/SPSelectWithEnum';

import { Form, Input, Button, Select, Row, Col } from 'antd';


import emiter, { EVENT_CARRENTAL_STORE_SEARCH } from '../../../../events';

import SPCitySelect from '../SPCitySelect';
import {DEFAULT_PAGE_INFO} from "../../../../consts";

interface PropsType {
    enums?: any;
}

const SPStoreListSearchForm: React.FC<PropsType> = (props) => {
  const { enums } = props;

  const { store_status } = enums || {};


  const searchButtonText = '搜索';
  const clearButtonText = '清空';
  const searchFormFields = {
    chengshi: {name: 'city_id', label: '城市', placeholder: '请选择城市'},
    mendianwangdianmingcheng: {name: 'store_name', label: '门店名称', placeholder: '请输入门店名称'},
    storeStatus: { name: 'store_status', label: '门店状态', placeholder: '请选择门店状态' },
    examineStatus: { name: 'audit_status', label: '审核状态', placeholder: '请选择审核状态', initialValue: -1 }
  };

  const [searchForm] = Form.useForm();

  const onSearchFormReset = () => {
    searchForm.resetFields();
    emiter.emit(EVENT_CARRENTAL_STORE_SEARCH, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  const handleSearch = () => {
    emiter.emit(EVENT_CARRENTAL_STORE_SEARCH, {
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  return (
    <Form form={searchForm}>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            name={searchFormFields?.chengshi.name}
            label={searchFormFields?.chengshi.label}
          >
            <SPCitySelect placeholder={searchFormFields?.chengshi.placeholder} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={searchFormFields?.mendianwangdianmingcheng.name}
            label={searchFormFields?.mendianwangdianmingcheng.label}
          >
            <Input placeholder={searchFormFields?.mendianwangdianmingcheng.placeholder} allowClear />
          </Form.Item>
        </Col>
         <Col span={8}>
          <Form.Item
            name={searchFormFields?.storeStatus.name}
            label={searchFormFields?.storeStatus.label}
          >
            <Select
              allowClear
              placeholder={searchFormFields?.storeStatus?.placeholder}
              mode="multiple"
            >
              {(store_status || []).map((item: any, index: number) => (<Select.Option key={index} value={item.key}>{item.value}</Select.Option>))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
              name={searchFormFields?.examineStatus.name}
              label={searchFormFields?.examineStatus.label}
              initialValue={searchFormFields?.examineStatus.initialValue}
          >
            <SPSelectWithEnum  enums={enums}
                               enumKey={'audit_status'}></SPSelectWithEnum>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type="primary" style={{ marginRight: '12px' }} onClick={handleSearch}>{searchButtonText}</Button>
        <Button onClick={onSearchFormReset}>{clearButtonText}</Button>
      </Form.Item>
    </Form>
  );
};

export default SPStoreListSearchForm;

